import { render, staticRenderFns } from "./mindOverMatter.vue?vue&type=template&id=6ebb17fa&"
import script from "./mindOverMatter.vue?vue&type=script&lang=js&"
export * from "./mindOverMatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports